import { render } from "./layerLandImpact.vue?vue&type=template&id=733f99a8&ts=true"
import script from "./layerLandImpact.vue?vue&type=script&lang=ts"
export * from "./layerLandImpact.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__